import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import {HeaderComponent} from './components/header/header.component';
import {FooterComponent} from './components/footer/footer.component';
import {TextsComponent} from './components/elements/texts/texts.component';
import {ToastNotificationComponent} from './components/elements/toast-notification/toast-notification.component';
import {MenuComponent} from './components/elements/menu/menu.component';
import {Location, NgIf} from '@angular/common';
import {ThemeService} from './services/theme.service';
import {FooterService} from './services/footer-service';
import {FcLoadingComponent} from './components/elements/fc-loading/fc-loading.component';
import {LoadingService} from './services/loading-service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, HeaderComponent, FooterComponent, TextsComponent, ToastNotificationComponent, MenuComponent, NgIf, FcLoadingComponent],
  templateUrl: './app.component.html',
  standalone: true,
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, OnDestroy {
  constructor(public themeService: ThemeService,
              public footerService: FooterService,
              public loading: LoadingService,
              public location: Location,) {}
  title = 'ilovefirstclass';
  showFooter = false;

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (document.documentElement.scrollTop === 0) {
      window.scrollTo(0, 1);
    }
    this.showFooter = this.checkPosition();
  }

  ngOnInit() {
    this.checkPosition();
  }

  checkPosition() {
    if (document.documentElement.scrollHeight <= window.innerHeight) {
      return false;
    }
    if (this.location.path() === '/feedback') {
      return false;
    }
    const scrollTop = document.documentElement.scrollTop;
    const clientHeight = document.documentElement.clientHeight;
    const scrollHeight = document.documentElement.scrollHeight;
    const distanceToBottom = scrollHeight - scrollTop - clientHeight;
    const threshold = scrollHeight > clientHeight * 2 ? clientHeight * 2 : clientHeight;
    return distanceToBottom <= threshold;
  };

  ngOnDestroy(): void {
    window.scrollTo(0, 0);
  }

}
